<div class="row member-bar mb-2">
    <div class="">
        <span>Welcome {{name}}</span>
        <a (click)="logout()" tabindex="0" class="float-right logout-link">{{'MEMBER_BAR.LOGOUT' | translate}}</a>
        <span class="float-right mr-1 ml-1"> | </span>
        <a tabindex="0" *ngIf="currentLink === '/account'" href="./departments"
            class="float-right">{{'MEMBER_BAR.JOURNEY_LINK' | translate}}</a>
        <a tabindex="0" *ngIf="currentLink !== '/account'" href="./account" target="_blank"
            class="float-right">{{'MEMBER_BAR.MY_ACCOUNT_LINK' | translate}}</a>
    </div>
</div>
<hr class="mt-2 mb-2 member-bar-seperator" />